import { combineReducers } from "redux";
import deviceReducer from "./device-reducer";
import authReducer from "./auth-reducer";
import assetReducer from "./asset-reducer";
import assetOldReducer from "./asset_old-reducer";
import userReducer from "./user-reducer";
import locationReducer from "./location-reducer";
import organizationReducer from "./organization-reducer";
import rolesReducer from "./roles-reducer";
import globalSearchReducer from "./globalSearch-reducer";
import singleDeviceReducer from "./singleDevice-reducer";
import alertReducer from "./alert-reducer";
import insightReducer from "./insight-reducer";
import devicesReducer from "./devices-reducer";
import singleDeviceHeaderReducer from "./singleDeviceHeader-reducer";
import deviceMapReducer from "./deviceMap-reducer";
import deviceDashboardReducer from "./deviceDashboard-reducer";
import deviceExplorerReducer from "./deviceExplorer-reducer";
import shipmentReducer from "./shipment-reducer";
import deviceProfileReducer from "./deviceProfile-reducer";
import alertsGroupReducer from "./alerts-group-reducer";
import deviceShipmentsDashboardReducer from "./deviceShipmentsDashboard-reducer";
import alertShipmentReducer from "./alertShipment-reducer";
import singleAssetReducer from "./singleAsset-reducer";


const rootReducer = combineReducers({
  deviceReducer,
  auth: authReducer,
  asset: assetReducer,
  assetOld: assetOldReducer,
  user: userReducer,
  location: locationReducer,
  organization: organizationReducer,
  roles: rolesReducer,
  globalSearch: globalSearchReducer,
  singleDevice: singleDeviceReducer,
  alert: alertReducer,
  insight: insightReducer,
  devices: devicesReducer,
  singleDeviceHeader: singleDeviceHeaderReducer,
  deviceMap: deviceMapReducer,
  deviceDashboard: deviceDashboardReducer,
  shipmentDashboard:deviceShipmentsDashboardReducer,
  deviceExplorer: deviceExplorerReducer,
  shipment: shipmentReducer,
  deviceProfile :deviceProfileReducer,
  alertsGroup: alertsGroupReducer,
  alertsShipment: alertShipmentReducer,
  singleAsset: singleAssetReducer,
});

export default rootReducer;
